<template>
  <div class="col">
    <zbm-async-content :loading="isLoading">
      <template v-slot:loading>
        <div class="row">
          <div class="col-auto pr-16 pb-16">
            <q-skeleton type="rect" width="100px" height="30px" />
          </div>
          <div class="col-auto pr-16">
            <q-skeleton type="rect" width="100px" height="30px" />
          </div>
          <div class="col-12 pb-24">
            <q-skeleton type="rect" width="100%" height="4px" />
          </div>
          <div class="col-12">
            <q-skeleton type="rect" width="100%" height="400px" />
          </div>
        </div>
      </template>
      <div v-if="isSurgicalProcedure" class="row">
        <div class="col">
          <SubNavigationLayout :class="'the-dashboard-education'" :title="'gen_education'" :type="'tab'" :navItems="tabNav">
            <template v-slot:more-info>
              <div class="col-auto pl-0">
                <zbm-btn-icon icon="fa-light fa-circle-question" @click="onQuestionClick" size="26px"
                              :buttonHeight="$zb.enums.ButtonHeightEnum.lg" class="text-dark-teal" color="white" />
              </div>
            </template>
          </SubNavigationLayout>
        </div>
      </div>
      <div v-if="!isSurgicalProcedure" class="row">
        <div class="col-auto pl-0">
          <div>
            <h1>{{ t('gen_education') }}</h1>
            <br />
          </div>
          <div>
            <slot name="content">
              <router-view :key="'Dashboard.Education.NonSurgical'" v-slot="{ Component }">
                <keep-alive>
                  <component :is="Component" />
                </keep-alive>
              </router-view>
            </slot>
          </div>
        </div>
      </div>
</zbm-async-content>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useDashboardStore, useGeneralPurposeModalStore, useSessionStore } from 'src/store';
  import SubNavigationLayout from 'src/components/layouts/SubNavigation/SubNavigationLayout.vue';
  import { useI18n } from 'vue-i18n';
  import { GeneralPurposeVariant } from '@/constants/enums';
  import { reformatString } from '@/utils/stringUtils';
  import { type SubNavItem } from '@/types/webContracts';
  import { setSelectedProcedure } from '../../api/endpoints/userWeb';

  const generalPurposeModalStore = useGeneralPurposeModalStore(),
    { t } = useI18n(),
    dashboardStore = useDashboardStore(),
    sessionStore = useSessionStore(),
    isSurgicalProcedure = computed(() => sessionStore.selectedProcedure?.isSurgicalProcedure),
    tabNav = computed(() => {
      const rawTabNav = [
        {
          value: 1,
          label: t('education_pre_surgery'),
          name: 'Dashboard.Education.PreSurgery',
        },
        {
          value: 2,
          label: t('education_post_surgery'),
          name: 'Dashboard.Education.PostSurgery',
        },
        {
          value: 3,
          label: t('rosa'),
          name: 'Dashboard.Education.Technology',
        }
      ] as SubNavItem[];
      
      const l = rawTabNav.sort((a, b) => a.value - b.value);

      if (dashboardStore.patient && !dashboardStore.patient.showRosaEducation) {
        return l.filter(o => o.value !== 3);
      }

      return l;
    }),

    isLoading = computed(() => {
      return !dashboardStore.patient;
    }),

    kvp = computed(() => {
      if (dashboardStore.patient?.showRosaEducation) {
        return 'rosa_help_content';
      }
      return 'education_help'
    });

  function onQuestionClick() {
    generalPurposeModalStore.setModal({
      variant: GeneralPurposeVariant.Information,
      title: t('education_info').toString(),
      template: reformatString(t(kvp.value).toString())
    });
  }
</script>
